import {
  DeleteOutlined,
  EditOutlined,
  InboxOutlined,
  PlusOutlined,
  RollbackOutlined,
} from '@ant-design/icons'
import { Space } from 'antd'
import { Button } from '@crosscode/gravity-components'
import styles from '@/pages/CashPage.module.css'

interface Props {
  archiveTab: boolean
  selectedCount: number
  onAdd: () => void
  onBulkArchive: () => void
  onBulkRestore: () => void
  onBulkDelete: () => void
  onDone: () => void
}

export function CashManageBar({
  archiveTab,
  selectedCount,
  onAdd,
  onBulkArchive,
  onBulkRestore,
  onBulkDelete,
  onDone,
}: Props) {
  return (
    <div className={styles.manageBar}>
      <div className={styles.manageBarLeft}>
        <span className={styles.typeChip}>Редактирование</span>
        <span className={styles.manageBarMeta}>
          {selectedCount > 0
            ? `Выбрано: ${selectedCount}`
            : archiveTab
              ? 'Выберите кассы для восстановления или удаления'
              : 'Выберите кассы или добавьте новую'}
        </span>
      </div>
      <Space wrap size={8}>
        {!archiveTab ? (
          <>
            <Button type="primary" icon={<PlusOutlined />} onClick={onAdd}>
              Добавить
            </Button>
            {selectedCount > 0 ? (
              <Button icon={<InboxOutlined />} onClick={onBulkArchive}>
                В архив ({selectedCount})
              </Button>
            ) : null}
          </>
        ) : (
          <>
            {selectedCount > 0 ? (
              <>
                <Button icon={<RollbackOutlined />} onClick={onBulkRestore}>
                  Восстановить ({selectedCount})
                </Button>
                <Button danger icon={<DeleteOutlined />} onClick={onBulkDelete}>
                  Удалить ({selectedCount})
                </Button>
              </>
            ) : null}
          </>
        )}
        <Button onClick={onDone}>Готово</Button>
      </Space>
    </div>
  )
}
